const comparisonPage = document.querySelector('.room-comparison');

if (comparisonPage) {
    const currentComparison = window.localStorage.getItem('comparison');
    const teaserRooms = document.querySelectorAll('.room-compare-teaser'); //Wrapper
    const backTeaserRooms = document.querySelector('.room-compare-empty'); //Leeres Teaser zur Übersicht, standardmäßig ausgeblendet
    const deleteBtns = document.querySelectorAll('.room-compare-teaser__delete'); //Icon zum Löschen

    let comparisonArray = JSON.parse(currentComparison);

    if (!Array.isArray(comparisonArray)) {
        comparisonArray = [];
    }

    teaserRooms.forEach((teaserRoom) => {
        if (comparisonArray.includes(teaserRoom.dataset.id)) {
            teaserRoom.classList.add('room-compare-teaser--show');
        }
    });

    deleteBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            const parentElement = e.target.closest('.room-compare-teaser');
            parentElement.classList.remove('room-compare-teaser--show');

            comparisonArray = comparisonArray.filter((id) => id !== parentElement.dataset.id);
            window.localStorage.setItem('comparison', JSON.stringify(comparisonArray));

            if (comparisonArray.length < 3) {
                backTeaserRooms.classList.add('room-compare-empty--show');
            }
        });
    });

    if (comparisonArray.length < 3) {
        backTeaserRooms.classList.add('room-compare-empty--show');
    }
}
